import React from "react";
import { HyroLoader } from "@hyro-components";
import HyroFeedbackMessage from "@hyro-components/HyroFeedbackMessage";
import AgentSettingsContent from "./AgentSettingsContent";
import useAgentSettings from "./AgentSettings.hook";

const AgentSettings = () => {
  const {
    isAdminContext,
    isPublishDialogOpen,
    setIsPublishDialogOpen,
    assistantSettingsProps,
    areSettingsChanged,
    isLoading,
    handlePublish,
    feedbackConfig,
    setFeedbackConfig,
    settingsInitialData,
    deploymentFieldProps,
    isDeploymentSubmitting,
    analyticsSettingsProps,
    isReadOnly
  } = useAgentSettings();

  if (!assistantSettingsProps?.accountName?.value) {
    return <HyroLoader />;
  }

  return (
    <>
      <AgentSettingsContent
        isAdminContext={isAdminContext}
        assistantSettingsProps={assistantSettingsProps}
        areSettingsChanged={areSettingsChanged}
        isLoading={isLoading}
        isPublishDialogOpen={isPublishDialogOpen}
        setIsPublishDialogOpen={setIsPublishDialogOpen}
        onPublish={handlePublish}
        settingsInitialData={settingsInitialData}
        deploymentFieldProps={deploymentFieldProps}
        isDeploymentSubmitting={isDeploymentSubmitting}
        analyticsSettingsProps={analyticsSettingsProps}
        isReadOnly={isReadOnly}
      />
      <HyroFeedbackMessage
        message={feedbackConfig.message}
        severity={feedbackConfig.severity}
        showFeedback={feedbackConfig.show}
        closeFeedback={() => setFeedbackConfig(state => ({ ...state, show: false }))}
      />
    </>
  );
};

export default AgentSettings;
